// Created by 任泽阳. // otc支付方式 // *****************************
<template>
  <span class="common-otcPayIcon" :class="className" @click="handClick">
    <svg-icon v-if="payment" :icon-class="getIconClassName(payment)"></svg-icon>
    <img v-else :src="imgUrl" />
  </span>
</template>
<script>
export default {
  name: 'c-otcPayIcon',
  props: {
    imgUrl: { type: String, default: '' },
    className: { type: String, default: '' },
    payment: {
      type: String,
      default: '',
    },
  },
  methods: {
    handClick() {
      this.$emit('click');
    },
    getIconClassName(key) {
      const iconMap = {
        'otc.payment.alipay': 'icon-ali',
        'otc.payment.wxpay': 'icon-wechat',
        'otc.payment.domestic.bank.transfer': 'icon-bank',
      };
      return iconMap[key];
    },
  },
};
</script>

<style lang="scss" scoped>
.common-otcPayIcon {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  display: inline-block;
  margin-right: 10px;
  text-align: center;
  border-radius: 2px;
  cursor: pointer;

  img {
    width: 24px;
    height: 24px;
    display: inline-block;
  }
}
</style>
